module.exports = __webpack_public_path__ + "img/ico_logo_white.d9ff1292.svg";